import { render, staticRenderFns } from "./ActionDocuments.vue?vue&type=template&id=1764c9d6&scoped=true"
import script from "./ActionDocuments.vue?vue&type=script&lang=ts"
export * from "./ActionDocuments.vue?vue&type=script&lang=ts"
import style0 from "./ActionDocuments.vue?vue&type=style&index=0&id=1764c9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1764c9d6",
  null
  
)

export default component.exports